import React from "react";
import { Route, Routes } from "react-router-dom";
import Imperiality from "../all_quality_management/general_requirement/imperiality/Imperiality";
import Confidentiality from "../all_quality_management/general_requirement/confidentiality/Confidentiality";
import ISStandard from "../all_quality_management/structural_requirement/iSStandard/ISStandard";
import Legel_Entity from "../all_quality_management/structural_requirement/legel_Entity/LegelEntity";
import ProcedureManual from "../all_quality_management/structural_requirement/procedureManual/ProcedureManual";
import QualityManual from "../all_quality_management/structural_requirement/qualityManual/QualityManual";
import ScopeOfTheLaboratory from "../all_quality_management/structural_requirement/scopeOfTheLaboratory/ScopeOfTheLaboratory";
import SOP from "../all_quality_management/structural_requirement/sop/SOP";
import Objectives from "../all_quality_management/structural_requirement/objectives/Objectives";
import OrganizationChart from "../all_quality_management/structural_requirement/organization_Chart/OrganizationChart";
import Quality_Policy from "../all_quality_management/structural_requirement/quality_Policy/QualityPolicy";
import Personnel_Details from "../all_quality_management/resource_requirement/personnel_details/Personnel_Details";
import Environment_Condition from "../all_quality_management/resource_requirement/environment-condition/Environment_Condition";
import Equipments from "../all_quality_management/resource_requirement/equipments/Equipments";
import Externally_Service from "../all_quality_management/resource_requirement/externally_Service/Externally_Service";
import Metrological_traceability from "../all_quality_management/resource_requirement/metrological_traceability/Metrological_traceability";
import Review_contract from "../all_quality_management/process_requirement/review_contract/Review_contract";
import Selection_method from "../all_quality_management/process_requirement/selection_method/Selection_method";
import Quality_Plan from "../all_quality_management/process_requirement/quality_Plan/Quality_Plan";
import Handling_item from "../all_quality_management/process_requirement/handling_item/Handling_item";
import Measurement_Uncertainty from "../all_quality_management/process_requirement/measurement_Uncertainty/Measurement_Uncertainty";
import Ensuring_results from "../all_quality_management/process_requirement/ensuring_results/Ensuring_results";
import Complaints from "../all_quality_management/process_requirement/complaints/Complaints";
import Non_Work from "../all_quality_management/process_requirement/non_Work/Non_Work";
import Management_requirement from "../all_quality_management/management_requirement/Management_requirement";
import Edit_Internal_Audit from "../all_quality_management/management_requirement/internal_Audit/edit_Internal_Audit/Edit_Internal_Audit";
import { FixIDS } from "../../../../utils/fixIDS";
import { ProtectedRoute } from "../../../../utils/common";
import NoAccess from "../../../NoAccess/noaccess";

const Quality_Management_Routes = () => {
  return (
    <Routes>
      {/* /general-requirement routes */}
      <Route path="general-requirement/imperiality" element={<Imperiality />} />

      <Route
        path="general-requirement/confidentiality"
        element={<Confidentiality />}
      />

      {/* /structural-requirement routes */}
      <Route
        path="structural-requirement/legel-entity"
        element={<Legel_Entity />}
      />

      <Route path="tructural-requirement/objectives" element={<Objectives />} />
      <Route
        path="structural-requirement/organization-chart"
        element={<OrganizationChart />}
      />
      <Route
        path="structural-requirement/quality-policy"
        element={<Quality_Policy />}
      />
      {/*inner routes(of /structural-requirement) managementdate routes  */}
      <Route
        path="structural-requirement/general-requirement/management-date-confidentiality/is-standard"
        element={<ISStandard />}
      />
      <Route
        path="structural-requirement/general-requirement/management-date-confidentiality/procedure-manual"
        element={<ProcedureManual />}
      />
      <Route
        path="structural-requirement/general-requirement/management-date-confidentiality/quality-manual"
        element={<QualityManual />}
      />
      <Route
        path="structural-requirement/general-requirement/management-date-confidentiality/scope-of-the-laboratory"
        element={<ScopeOfTheLaboratory />}
      />
      <Route
        path="structural-requirement/general-requirement/management-date-confidentiality/sop"
        element={<SOP />}
      />

      {/* /resource-requirement routes */}
      <Route
        path="resource-requirement/personnel-details"
        element={<Personnel_Details />}
      />
      <Route
        path="resource-requirement/environment-condition"
        element={<Environment_Condition />}
      />
      <Route path="resource-requirement/equipments" element={<Equipments />} />
      <Route
        path="resource-requirement/metrological-traceability"
        element={<Metrological_traceability />}
      />
      <Route
        path="resource-requirement/externally-service"
        element={<Externally_Service />}
      />

      {/* /process-requirement routes */}
      <Route
        path="process-requirement/review-contract"
        element={<Review_contract />}
      />
      <Route
        path="process-requirement/selection-method"
        element={<Selection_method />}
      />
      <Route
        path="process-requirement/quality-plan"
        element={<Quality_Plan />}
      />
      <Route
        path="process-requirement/handling-item"
        element={<Handling_item />}
      />
      <Route
        path="process-requirement/measurement-uncertainty"
        element={<Measurement_Uncertainty />}
      />
      <Route
        path="process-requirement/ensuring-results"
        element={<Ensuring_results />}
      />
      <Route path="process-requirement/Complaints" element={<Complaints />} />
      <Route path="process-requirement/non-work" element={<Non_Work />} />

      <Route
        path="management-system-requirement"
        element={<Management_requirement />}
      />
      <Route path="/no-access" element={<NoAccess />} />
    </Routes>
  );
};

export default Quality_Management_Routes;
